module.exports = __webpack_public_path__ + "img/mp.7cbdc372.svg";